import React from 'react';

function ContactForm() {
  return (
      <section className="tc-contact-form-style1">
        <div className="container">
          <div className="row justify-content-between">
            <div className="col-lg-4">
              <div className="info wow fadeInUp slow" data-wow-delay="0.2s">
                <h3 className="fsz-45 fw-500 mb-80">
                  Arsanız mı var? <br /> Gelin birlikte değerlendirelim!
                </h3>
                <p className="fsz-14 color-666 mt-15">
                  Bilgileriniz gizli tutulur. <br />
                  <span className="text-danger">*</span> işaretli alanlar
                  zorunludur.
                </p>
              </div>
            </div>
            <div className="col-lg-6">
              <form
                  action=""
                  className="form mt-5 mt-lg-0 wow fadeInUp slow"
                  data-wow-delay="0.4s"
              >
                <div className="row">
                  <div className="col-lg-6">
                    <div className="form-group mb-30">
                      <label htmlFor="">
                        Ad Soyad <span className="color-orange1">*</span>
                      </label>
                      <input
                          type="text"
                          className="form-control"
                          placeholder="Adınızı girin"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form-group mb-30">
                      <label htmlFor="">
                        E-posta <span className="color-orange1">*</span>
                      </label>
                      <input
                          type="email"
                          className="form-control"
                          placeholder="E-posta adresiniz"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form-group mb-30">
                      <label htmlFor="">
                        Telefon <span className="color-999">(isteğe bağlı)</span>
                      </label>
                      <input
                          type="text"
                          className="form-control"
                          placeholder="Telefon numaranız"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form-group mb-30">
                      <label htmlFor="">
                        Başlık <span className="color-orange1">*</span>
                      </label>
                      <select name="" id="" className="form-select form-control">
                        <option value="">Konu seçin</option>
                        <option value="">Arsa analizi talebi</option>
                        <option value="">Ortak proje önerisi</option>
                        <option value="">Bilgi almak istiyorum</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="form-group mb-30">
                      <label htmlFor="">Mesajınız</label>
                      <textarea
                          rows="6"
                          placeholder="Arsanızla ilgili detayları paylaşabilirsiniz..."
                          className="form-control"
                      ></textarea>
                    </div>
                  </div>
                </div>
                <a
                    href="#"
                    className="butn hover-bg-orange1 text-capitalize bg-white rounded-pill mt-40"
                >
                <span>
                  Formu Gönder
                  <i className="fal fa-arrow-up-right ms-2"></i>
                </span>
                </a>
                <p className="fsz-12 color-666 mt-20">
                  Gönderim yaparak
                  <a href="#" className="color-000 text-decoration-underline ms-1">
                    Gizlilik Politikası
                  </a>
                  'nı kabul etmiş olursunuz.
                </p>
              </form>
            </div>
          </div>
        </div>
        <img
            src="/innerpages/assets/img/contact_shap.png"
            alt=""
            className="shap"
        />
      </section>
  );
}

export default ContactForm;